import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Main from "./pages/Main/Main";
// import AboutUs from "./pages/AboutUs/AboutUs";
// import TestDrive from "./pages/TestDrive/TestDrive";
import ContactUs from "./pages/Contact Us/ContactUs";
import Service from "./pages/Service/Service";
import TradeIn from "./pages/TradeIn/TradeIn";
import Guarantee from "./pages/Guarantee/Guarantee";
import Header from "./NavBars/Header/Header";
import Explore from "./pages/Explore/Explore";
import Footer from "./NavBars/Footer/Footer";
import ScrollToTop from "./Animations/ScrollToTop";

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Main />} />
        {/* <Route path="/AboutUs" element={<AboutUs />} /> */}
        {/* <Route path="/TestDrive" element={<TestDrive />} /> */}
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Service" element={<Service />} />
        <Route path="/TradeIn" element={<TradeIn />} />
        <Route path="/Guarantee" element={<Guarantee />} />
        <Route path="/Explore" element={<Explore />} />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
